import { useRef } from "react";
import { Divider, useMediaQuery, useTheme } from "@mui/material";
import { IColoredTagGroup, ITagsData } from "src/api/server/extended-search";
import { BrokersCheckboxList } from "src/components/pages/search/components/tags-filter/components/brokers-checkbox-list";
import { TagsList } from "src/components/pages/search/components/tags-filter/components/tags-list";
import { SAVINGS_PLAN_TAG } from "src/components/pages/search/constants";
import { ISearch } from "src/components/pages/search/search.types";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { EnumTagColor } from "src/types/common-enum";

interface ITagsListWithBrokers extends ISearch {
    tagsData: ITagsData;
    showBrokers?: boolean;
}

export const TagsListWithBrokers = ({ tagsData, onSearch }: ITagsListWithBrokers) => {
    const { tags: selectedTags } = useSearchStore();
    const showBrokers = selectedTags.some(tag => tag.value === SAVINGS_PLAN_TAG);
    const { tags, brokers } = tagsData;
    const { basics, tradings, rewards, investmentHorizon, investmentRegion, alphaBeta } = tags;

    const brokerListRef = useRef<null | HTMLDivElement>(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const orderedTagGroups: IColoredTagGroup[] = [
        {
            tags: rewards.tags,
            color: EnumTagColor.Green,
        },
        {
            tags: tradings.tags,
            color: EnumTagColor.Lilac,
        },
        {
            tags: investmentHorizon.tags,
            color: EnumTagColor.Blue,
        },
        {
            tags: investmentRegion.tags,
            color: EnumTagColor.Orange,
        },
        {
            tags: alphaBeta.tags,
            color: EnumTagColor.Teal,
        },
        {
            tags: basics.tags,
            color: EnumTagColor.Gray,
        },
    ];

    const onTagClick = (isChecked: boolean, value: string) => {
        if (value === SAVINGS_PLAN_TAG && isChecked && isMobile) {
            setTimeout(() => {
                brokerListRef?.current?.scrollIntoView({ behavior: "smooth" });
            }, 1000);
        }
    };

    return (
        <>
            <TagsList tags={tags} onSearch={onSearch} onClick={onTagClick} orderedTagGroups={orderedTagGroups} />
            {showBrokers && (
                <>
                    <Divider sx={{ pt: 3 }} />
                    <BrokersCheckboxList onSearch={onSearch} pt={3} brokers={brokers} ref={brokerListRef} />
                </>
            )}
        </>
    );
};
